'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseIcons = require('@bibliocommons/base-icons');

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

require('../styles/BlueCaretArrowButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function BlueCaretArrowButton(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$children = _ref.children,
      children = _ref$children === undefined ? '' : _ref$children,
      _ref$caretUp = _ref.caretUp,
      caretUp = _ref$caretUp === undefined ? false : _ref$caretUp,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'caretUp']);

  return _react2.default.createElement(
    _button2.default,
    _extends({}, props, { className: 'cp-blue-caret-arrow-button ' + className }),
    children,
    caretUp ? _react2.default.createElement(_baseIcons.Carets.Up, null) : _react2.default.createElement(_baseIcons.Carets.Down, null)
  );
}

BlueCaretArrowButton.propTypes = {
  className: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node), _react2.default.PropTypes.node]).isRequired,
  caretUp: _react2.default.PropTypes.bool
};

exports.default = BlueCaretArrowButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/blue-caret-arrow/components/BlueCaretArrowButton.component.js
// module id = 1031
// module chunks = 1